import client from "./Client";

client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("careToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      handleTokenExpiration();
    }
    return Promise.reject(error);
  }
);

function handleTokenExpiration() {
  clearToken();
  window.location.href = "/";
}

function clearToken() {
  localStorage.removeItem("careToken");
}

const Api = {
  login: (email, password) => client.post(`/admin/login`, { email, password }),
  verifyOTP: (email, otp) =>
    client.post(`/admin/verify-otp-for-login`, { email, otp }),
  resendOTP: (email) => client.post(`/admin/resend-otp`, { email }),

  get_admin_data: (id) => client.get(`/admin/get-admin-details/${id}`),

  get_hospitals: () => client.get(`/admin/healthFacility/get-hospitals`),
  get_pharmacy: () => client.get(`/admin/healthFacility/get-pharmacies`),
  get_lab: () => client.get(`/admin/healthFacility/get-laboratories`),
  get_fitness: () => client.get(`/admin/healthFacility/get-fitnessCenters`),
  getServiceData: () => client.get("/get-service-data"),

  get_doctor: () => client.get(`/admin/healthProfessional/get-doctors`),
  get_nurse: () => client.get(`/admin/healthProfessional/get-nurses`),
  get_phys: () => client.get(`/admin/healthProfessional/get-physiotherapists`),
  get_request: () => client.get(`/admin/requests/get-requests`),
  get_scientist: () =>
    client.get(`/admin/healthProfessional/get-medicalLabScientists`),

  updateAdmin: async (id, formData) => {
    try {
      const res = await client.put(
        `/app/admin/updateAdminDetails/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      return res.data;
    } catch (error) {
      console.error("API error:", error);
      throw error;
    }
  },
  changePassword: async (passwordData) => {
    console.log("passwordData", passwordData);
    try {
      const response = await client.post(
        "/app/admin/changePassword",
        passwordData
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  resetPasswordAfterOtp: async (passwordData) => {
    try {
      const response = await client.put(`/admin/reset-password`, passwordData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  changeProviderPassword: async (payload, token) => {
    const response = await client.put(
      "/admin/profile/change-password",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },
  getAdminInfo: (token) =>
    client.get("/admin/profile/get-admin-info", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }),

  updateAdminInfo: (formData, token) =>
    client.put("/admin/profile/update-admin-info", formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    }),

  addNewService: async (payload, token) => {
    const response = await client.post(
      "/admin/services/add-new-service",
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  },
};

//export const getServiceData = () => client.get("/get-service-data");
export default Api;
